/** Contato do projeto: dúvidas, avisos de erro e pedidos sobre dados (LGPD, art. 18). Mostrado nos termos e no "Sobre". */
export const EMAIL_CONTATO = 'helvecio.leal@ufopa.edu.br';
